<template>
    <v-dialog :value="exibirModal" persistent :max-width="Modal.Processamento.larguraMaxima">
        <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Itens a confirmar
                </span>
            </v-card-title>
            <v-card-text class="mensagem-aviso">
                <div class="pa-1" style="border-radius: 5px">
                    <div style="border-radius: 5px; text-align: center;">
                        <strong class="red--text">️ ⚠️ Atenção!!!</strong>
                        Identificamos que alguns valores informados estão muito abaixo do valor de referência,
                        por favor verifique e confirme cada valor para enviar a sua proposta.
                    </div>
                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text style="overflow-y: auto; max-height: 300px">
                <tabela-reinserir-valores-itens :itens="itens"/>
            </v-card-text>
            <v-card-actions class="px-3 py-2">
                <v-btn id="botaoConfirmar"
                       @click="$emit('confirmar')"
                       flat outline color="botao-cancelar-color">
                    ENVIAR MESMO ASSIM
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaoFechar" @click="$emit('cancelar')" color="primary" depressed>
                    VOLTAR PARA CORRIGIR
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import TabelaReinserirValoresItens from './TabelaReinserirValoresItens'
import { Modal } from '@/core/constants'
export default {
    name: 'ModalConfirmacaoValores',
    components: {TabelaReinserirValoresItens},
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        itens:{
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed:{
        confirmarDesabilitado(){
            return this.itens.some(item => item.valor !== item.valorDigitado)
        }
    },
    data(){
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

    .legenda-destacada
        font-size 15px
        margin 8px 16px
        padding 5px 18px
        background-color #F69595
        border 1px solid #f76c62
        border-radius 3px
        display flex
        flex-direction row

        p
            margin 0

    .mensagem-aviso-reajuste
        color white
        text-align center

</style>
